document.addEventListener('DOMContentLoaded', function () {
    console.log('ally start');

    $('#header').attr('role','banner');
    setTimeout(() => {
        $('#header nav.tmenu_navbar').attr('aria-label','main');
$('.privacy-policy .shopify-policy__body .rte table').eq(0).prepend('<caption class="sr-only">Categories of Personal Information Disclosed and Recipients</caption>');
$('.privacy-policy .shopify-policy__body .rte table').eq(1).prepend('<caption class="sr-only">Categories of Personal Information Sold or Shared and Recipients</caption>');
$('body.our-store-reviews .blog-post-detail table').prepend('<caption class="sr-only">Customer Order and Review Details</caption>');
$('.reputon-top-part .reputon-rating-stars').attr({'role':'img','aria-label':'rating stars'});
$('body.contact-us .storeify-formbuilder .storeify-list-social a.fa-facebook').attr('aria-label','facebook');
$('body.contact-us .storeify-formbuilder input.storeify_form_attach_file').attr({'role':'button','aria-label':'attach file'});
$('body.main-faqs .bootstrap-ddshop .cd-faqitem h4,body.contact-us .storeify-formbuilder .preview_box_text').attr({'role':'heading','aria-level':'3'});
$('body.main-faqs .bootstrap-ddshop .cd-faq-title h3,body.contact-us .storeify-formbuilder .storeify-title-frm,body.collab .collabs-page__intro h1').attr({'role':'heading','aria-level':'2'});
$('body.main-faqs .ddshop-search-widget').prepend('<div class="faq_search_label" style="margin-bottom:4px;">Search</div>');
$('body.contact-us .storeify-formbuilder #storeifyInput_name').attr('autocomplete', 'name');
$('body.contact-us .storeify-formbuilder #storeifyInput_email').attr('autocomplete', 'email');
$('body.contact-us .storeify-formbuilder #storeifyInput_phone').attr('autocomplete', 'tel');
$('body.contact-us .storeify-formbuilder form .storeify-body-frm').prepend('<div class="required_message">Fields marked with * are required.</div>');
$('body.cart .boost-sd__product-info .stamped-badge').attr('role','img');
$('.section-scrolling-images .scrolling-images--item .scrolling-images--content h6,a.tmenu_skip-link').remove();
$('.media-grid .media-grid--bg video img').attr('alt','');
$('.best-elevator-shoes-on-sale .collection-banner--description img').attr('alt','CLEARANCE SALE FINAL MARKDOWNS. UP TO 60% OFF');
    }, 2000);
    
    let slickDotsObserver = new MutationObserver(function () {
    if ($('.boost-sd__slider .slick-dots').length) {
        $('.boost-sd__slider .slick-dots button').each(function (index) {
            $(this).attr('aria-label', 'Go to slide ' + (index + 1));});
        $('.boost-sd__slider .slick-dots button').removeAttr('aria-current');
        $('.boost-sd__slider .slick-dots .slick-active button')
            .attr('aria-current', 'true');}});
slickDotsObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']});
(function () {
    function updateShowMore() {
        $('.reputon-slide .reputon-card').each(function () {
            var name = $(this).find('.reputon-name').first().text().trim();
            $(this).find('.reputon-show-more').attr('aria-label', 'Show more about ' + name);});}
    updateShowMore();
    new MutationObserver(updateShowMore).observe(document.body, {
        childList: true,
        subtree: true});
})();
window.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    const link = document.activeElement;
    if (
        !link ||
        !link.matches('.tmenu_item--root > .tmenu_item_link') ||
        !link.href ||
        link.getAttribute('href') === 'javascript:;'
    ) {return;}
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = link.href;}, true);
$(function () {$('body').addClass(location.pathname.split('/').filter(Boolean).pop());});
$('.shopify-policy__body ul li h3').attr({'role':'heading','aria-level':'2'});
$('.shopify-policy__body .rte p strong').filter(function () {return !$(this).children().length;}).attr({ role: 'heading', 'aria-level': '2' });
$('br').attr('aria-hidden','true');
(function () {
    function addStarLabels() {
        $('.reputon-rating-stars').each(function () {
            const $stars = $(this).children('svg[width="17"]');
            const total = $stars.length;
            const empty = $stars.filter('[fill="#ccc"]').length;
            const rating = total - empty;
            $(this).attr({role: 'img','aria-label': rating + ' out of ' + total + ' stars'});
            $stars.attr('aria-hidden', 'true');});
        $('.stamped-review-card .stamped-reviews-rating').each(function () {
            const rating = $(this).closest('.stamped-review-card').find('.stamped-reviews-message-image-block').attr('data-rating');
            if (rating) {
                $(this).attr({role: 'img','aria-label': rating + ' out of 5 stars'});
                $(this).find('i').attr('aria-hidden', 'true');}});
        $('.stamped-reviews-holder').each(function () {
    if ($(this).find('.stamped-reviews-location').text().trim() === 'France') {
        $(this).find('.stamped-reviews-message').attr('lang', 'fr');
    }
});
        $('.stamped-pagination #pages .stamped-pagination-page').each(function () {
            const $page = $(this);
            const $link = $page.find('a');
            if ($link.length) {
                const page = $link.attr('data-page');
                $link.attr('aria-label','Go to page ' + page);
                $link.attr('aria-current', 'false');$link.attr('tabindex', '0');}
            if ($page.hasClass('is-active')) {
                const page = $page.text().trim();
                $page.attr('aria-current', 'page');
                $page.find('a').attr({'aria-label': 'Current page, page ' + page,'aria-current': 'page'});}});
            }
    addStarLabels();
    const starObserver = new MutationObserver(function () {addStarLabels();});
    starObserver.observe(document.body, {childList: true,subtree: true});})();
// 
function convertPaginationSpans() {
    $('.stamped-pagination > div span').each(function () {
        const $span = $(this);
        const $div = $('<div>');
        $.each(this.attributes, function () {$div.attr(this.name, this.value);});
        $div.html($span.html());
        $span.replaceWith($div);});
    $('#pages').attr('role', 'list');
    $('#pages > div').each(function () {
        if ($(this).hasClass('stamped-pagination-deco')) {
            $(this).attr({'role':'presentation','aria-hidden':'true'});
        } else {$(this).attr('role', 'listitem');}});
}
convertPaginationSpans();
const paginationObserver = new MutationObserver(function () {convertPaginationSpans();});
paginationObserver.observe(document.body, {childList: true,subtree: true});
$(document).on('mousedown keydown', '.reputon-load-more', function (e) {
    if (e.type === 'keydown' && !['Enter', ' '].includes(e.key)) return;
    const $holder = $(this).closest('.reputon-reviews-holder');
    const old = $holder.find('.reputon-single-review').toArray();
    const observer = new MutationObserver(function () {
        const $new = $holder.find('.reputon-single-review').filter(function () {return !old.includes(this);}).first();
        if ($new.length) {
            observer.disconnect();
            setTimeout(() => $new.find('.reputon-name a').first().focus(), 200);}});
    observer.observe($holder[0], { childList: true, subtree: true });});
// 
if (!$('#search-status').length) {$('.ddshop-search-widget').append('<div id="search-status" aria-live="polite" aria-atomic="true" class="sr-only"></div>');}
function announceSearchResults() {
    const $results = $('.tt-dataset-faqitems');
    const count = $results.find('.tt-suggestion').length;
    const nothingFound = $results.find('.list-group-item').text().trim();
    if (nothingFound === 'Nothing found.') {
        $('#search-status').text('');
        setTimeout(function () {$('#search-status').text('Nothing found.');}, 100);
        return;}
    if (count === 0) return;
    $('#search-status').text('');
    setTimeout(function () {
        $('#search-status').text(count + (count === 1 ? ' suggestion found' : ' suggestions found'));}, 100);}
$('#ddshop-search-query').on('typeahead:rendered', function () {announceSearchResults();});
function updateStoreifyErrors() {
    $('.storeify-form-action .error').each(function () {
        if ($(this).text().trim() !== 'This field is required.') return;
        const field = $(this).attr('for');
        const label = $('label[for="' + field + '"]')
            .not('.error')
            .clone()
            .children().remove().end()
            .text().trim();
        $(this).text(label + ' is required.');});
    $('.storeify-formbuilder-mes.storeify-mes-success').attr('role', 'alert');}
updateStoreifyErrors();
const storeifyObserver = new MutationObserver(updateStoreifyErrors);
storeifyObserver.observe(document.body, {childList: true,subtree: true});
// 
if (!$('#storeify-loading').length) {$('body').append('<div id="storeify-loading" class="sr-only" aria-live="assertive" aria-atomic="true"></div>');}
let storeifySubmitting = false;
$(document).on('click', '.storeify-submit-frm', function (e) {
    if (storeifySubmitting) return;
    const name = $('#storeifyInput_name').val().trim();
    const email = $('#storeifyInput_email').val().trim();
    if (!name || !email) return;
    e.preventDefault();
    $('#storeify-loading').text('Loading...');
    const button = this;
    setTimeout(function () {
        storeifySubmitting = true;
        button.click();
        storeifySubmitting = false;
    }, 2000);});
// 
if (!$('#storeify-file-status').length) {$('body').append('<div id="storeify-file-status" class="sr-only" role="status" aria-live="polite" aria-atomic="true"></div>');}
$(document).on('change', '.storeify_form_attach_file', function () {
    const input = this;
    const $error = $('#form_attach_file_error_3131');
    setTimeout(function () {
        if ($error.is(':visible') && $error.text().trim()) {
            $('#storeify-file-status').text(
                'File not attached. ' + $error.text().trim());
        } else if (input.files.length) {
            $('#storeify-file-status').text(
                'File attached successfully.'
            );}
        input.focus();
    }, 500);});
// 
if ($('pagination-theme.pagination-type--paginated .page-numbers').length) {
    $('pagination-theme.pagination-type--paginated .page-numbers').attr({'role': 'navigation','aria-label': 'pagination'});
    $('pagination-theme.pagination-type--paginated .page-numbers .page').attr('role', 'listitem');
    $('pagination-theme.pagination-type--paginated .page-numbers .page a').each(function () {$(this).attr('aria-label', 'Page ' + $(this).text().trim());});
    $('pagination-theme.pagination-type--paginated .page-numbers .page.current').attr('aria-current', 'page');
    $('pagination-theme.pagination-type--paginated .page-numbers .deco').attr({'role': 'presentation','aria-hidden': 'true'});
    $('pagination-theme.pagination-type--paginated .page-numbers .prev a').attr('aria-label','Previous page');
    $('pagination-theme.pagination-type--paginated .page-numbers .next a').attr('aria-label','Next page');
}
// 

const stampedBadgeObserver = new MutationObserver(function () {
    $('.boost-sd__product-info .stamped-badge').attr('role', 'img');
    $('.boost-sd__product-item a.boost-sd__product-link').removeAttr('aria-labelledby');
    $('body.cart .reputon-content a.reputon-link:has(.reputon-rating-stars)').attr('aria-label', '4.8 reviews');
    $('body.cart .reputon-content .reputon-reviews-count svg').attr({'role':'img','aria-label':'Google'});
    $('body.cart .reputon-card .reputon-top-part .reputon-show-more').each(function () {
        const $btn = $(this);
        const name = $btn.closest('.reputon-card').find('.reputon-name').first().text().trim();
        const text = $btn.find('span').text().trim();
        $btn.attr({'aria-expanded': text === 'Show less' ? 'true' : 'false','aria-label': (text === 'Show less' ? 'Show less about ' : 'Show more about ') + name});
    });
    $('variant-swatch-king ul.swatch-view.swatch-view-button li.swatch-view-item').attr('tabindex','0');
    $('.storeify-formbuilder form .bg-success ul li i.storeify-delete-file').attr({'role':'button','aria-label':'X (Close)','tabindex':'0'}).removeAttr('aria-hidden');
    $('.boost-sd__recommendation .boost-sd__recommendation-title-text').removeAttr('tabindex');
    $('.boost-sd__recommendation .slick-track .slick-slide.slick-active').removeAttr('tabindex aria-label');
    $('.reputon-card .reputon-verified').each(function () {
    if (this.tagName !== 'BUTTON') {
        $(this).replaceWith('<button class="' + $(this).attr('class') + '" aria-label="Verified">' + $(this).html() + '</button>');
    }
});
    $('.stamped-wall-photos-wrapper .stamped-reviews-message-image-block a').attr({'role':'button','tabindex':'0'});
    $('.stamped-pagination-page.is-active').each(function () {
    if (!$(this).find('div').length) {
        $(this).wrapInner('<div role="link" tabindex="0"></div>');
    }
});
    $('quantity-selector.buttons_added button').each(function () {
    const $btn = $(this);
    if ($btn.hasClass('disabled')) {
        $btn.attr('disabled', 'disabled');
    } else {
        $btn.removeAttr('disabled');
    }
});
// 
if ($('.ht-tms__duo-selector__active-item').length) {
    $('.ht-tms__duo-selector__active-item').each(function () {
        const $this = $(this);
        const values = $this.find('.tms-element-text');
        if (values.length >= 3) {
            const currency = values.eq(0).text().trim();
            const language = values.eq(2).text().trim();
            $this.attr({'role': 'button','tabindex': '0','aria-label': 'Currency ' + currency + ', Language ' + language});}});}
// 
if ($('.main-slideshow .slideshow__slide').length) {
    $('.main-slideshow .slideshow__slide').each(function () {
        const $slide = $(this);
        if ($slide.hasClass('is-selected')) {
            $slide.attr('aria-hidden', 'false');
            $slide.find('a, button').attr('tabindex', '0');
        } else {
            $slide.attr('aria-hidden', 'true');
            $slide.find('a, button').attr('tabindex', '-1');
        }});}
if ($('iframe#merchantwidgetiframe').length) {$('iframe#merchantwidgetiframe').attr('title', 'Google Merchant widget');}
if ($('.stamped-rewards-launcher .stamped-launcher-button iframe').length) {$('.stamped-rewards-launcher .stamped-launcher-button iframe').attr('title', 'Rewards');}
// 
if ($('.main-slideshow .flickity-page-dots .dot').length) {
    $('.main-slideshow .flickity-page-dots .dot').each(function (index) {
        const $dot = $(this);
        const slideNumber = index + 1;
        $dot.removeAttr('aria-label');
        if (!$dot.find('button').length) {$dot.wrapInner('<button type="button"></button>');}
        const $button = $dot.find('button');
        $button.attr('aria-label', 'Slide ' + slideNumber);
        if ($dot.hasClass('is-selected')) {$button.attr('aria-current', 'true');
        } else {$button.removeAttr('aria-current');}});
    }
if ($('.tmenu_nav .tmenu_item .tmenu_item_link[aria-haspopup="true"]').length) {$('.tmenu_nav .tmenu_item .tmenu_item_link[aria-haspopup="true"]').each(function () {
        $(this).on('keydown', function (e) {if (e.key === 'Enter' || e.key === ' ') {e.preventDefault();this.click();}});});}
if ($('.tmenu_nav .tmenu_item .tmenu_item_link[href="javascript:;"]').length) {
    $('.tmenu_nav .tmenu_item .tmenu_item_link[href="javascript:;"]').each(function () {
        const $a = $(this);
        if (!$a.closest('li').hasClass('tmenu_item--root')) {
            $a.find('img').each(function () {
            const $img = $(this);
            if (!$img.attr('src')) {
            const srcset = $img.attr('data-srcset');
            if (srcset) {const src = srcset.split(',')[1].trim().split(' ')[0];
            $img.attr('src', src);}}});
            const $div = $('<div>');
            $.each(this.attributes, function () {if (this.name !== 'href') {$div.attr(this.name, this.value);}});
            $div.html($a.html());
            $a.replaceWith($div);}});
}
if ($('.tmenu_nav .tmenu_submenu').length) {$('.tmenu_nav .tmenu_submenu').attr('role', 'presentation');}
if ($('.tmenu_nav ul.tmenu_masonry_col.tmenu_masonry_col-4').length) {$('.tmenu_nav ul.tmenu_masonry_col.tmenu_masonry_col-4').attr('role', 'presentation');}
if ($('.stamped-summary-actions-newreview, .stamped-summary-actions-newquestion').length) {
    $('.stamped-summary-actions-newreview, .stamped-summary-actions-newquestion').each(function () {
        $(this).removeAttr('onkeydown');
    });
}
$('#stamped-main-widget .stamped-summary .stamped-review-options').removeAttr('aria-hidden');
$('#stamped-main-widget .stamped-summary .stamped-review-options ul').attr('rol','presentation');
$('#stamped-main-widget form.new-review-form .stamped-starrating a.stamped-fa').attr('role','checkbox');
$('#stamped-main-widget form.new-review-form .stamped-starrating').attr('role','group');
$('#stamped-main-widget form.new-review-form .stamped-file-uploader-btn').attr({'role':'button','tabindex':'0','aria-label':'Add Photos'});
$('.product-brand-features-padding .youtube-video iframe').attr('title','Modern Height Innovator - TMS');
$('#stamped-main-widget .stamped-messages .stamped-thank-you >p:first,.comments-wrapper .comment-respond form .form-notification.success,footer form#contact_form .form-notification.success').attr('role','alert');
$('.reputon-customer-reviews-widget #ratingWidget a').attr('aria-label','Google 4.7 Read our 1117 reviews');
$('.ht-tms__popup .ht-tms__popup__form .ht-tms__popup__regions').attr('tabindex','0');
$('.boost-sd__filter-product-list .boost-sd__product-count,.boost-sd-right .boost-sd__toolbar .boost-sd__tooltip .boost-sd__view-as-icon.boost-sd__view-as-icon--list-grid').removeAttr('tabindex');
$('.boost-sd__filter-tree-wrapper .boost-sd__filter-tree-vertical-option-list').attr('role','list');
$('.boost-sd__filter-tree-wrapper .boost-sd__filter-tree-vertical-option-list .boost-sd__filter-option').attr('role','listitem');
if ($('.mobile-toggle-wrapper').length) {
    $('.mobile-toggle-wrapper').each(function () {const $details = $(this);
    const $toggle = $details.find('.mobile-toggle');
    if ($details.hasClass('active')) {$toggle.attr('aria-expanded', 'true');} else {$toggle.attr('aria-expanded', 'false');}});
}
if ($('.stamped-rewards-launcher').length) {
    $('.stamped-rewards-launcher').each(function () {const $launcher = $(this);
        const $button = $launcher.find('.stamped-launcher-button');
        if ($launcher.hasClass('opened')) {$button.attr('aria-label', 'Close Rewards');} else {$button.attr('aria-label', 'Rewards');}});
}
if ($('.back-to-top').length) {
    $('.back-to-top').on('click keydown', function (e) {
        if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
        setTimeout(function () {$('a.screen-reader-shortcut').focus();}, 100);}});
}
if ($('.size-tabs .size-tab').length) {
    $('.size-tabs .size-tab').each(function () {
        const active = $(this).hasClass('active');
        $(this).attr({'aria-selected': active ? 'true' : 'false','tabindex': active ? '0' : '-1'});});
}
if ($('.size-tabs .size-tab').length) {
    $('.size-tabs .size-tab').off('keydown.sizeTabs').on('keydown.sizeTabs', function (e) {
        const $tabs = $('.size-tabs .size-tab');
        let i = $tabs.index(this);
        if (e.key === 'ArrowRight') i++;
        else if (e.key === 'ArrowLeft') i--;
        else return;
        e.preventDefault();
        i = (i + $tabs.length) % $tabs.length;
        $tabs.attr({'aria-selected':'false','tabindex':'-1'});
        $tabs.eq(i).attr({'aria-selected':'true','tabindex':'0'}).focus();});
}
$('.free-gifts .free-gifts-item .free-gifts-options select').attr('aria-label','Select size');
if ($('.upsells .upsell-item .upsell-image a').length) {$('.upsells .upsell-item .upsell-image a').each(function () {$(this).replaceWith($('<div>', {class: $(this).attr('class'),html: $(this).html()}));});}
$('img[src*="mak_360x.png"]').attr('alt','Born In Hollywood Making Men Taller Since 1999 Prestige Craftsmanship').removeAttr('title');
$('div.tmenu_masonry.tmenu_submenu--desktop ul.tmenu_masonry_col').attr('role','presentation');
$('img[src*="a05b2574dc734afe5f03e3beb0db3f6f21b3057ef907347a8a80abce75d16226.png"]').attr('alt','Shop Size In Stock Ship Same Day');
$('div.tmenu_item_link .tmenu_item_text').attr({'role':'heading','aria-level':'2'});
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    document.querySelectorAll(
        '.reputon-google-reviews-widget .go2487701701 .reputon-logo-text'
    ).forEach(function (el) {

        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');

        var parent = el.closest('.go2487701701');

        if (parent) {
            parent.addEventListener('mouseleave', function reset() {
                el.style.removeProperty('opacity');
                el.style.removeProperty('visibility');
                parent.removeEventListener('mouseleave', reset);
            }, { once: true });
        }
    });

    document.querySelectorAll(
        '.reputon-google-reviews-widget .go1784848022 .reputon-verified-label'
    ).forEach(function (el) {

        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('transform', 'none', 'important');

        var button = el.closest('.go1784848022');

        if (button) {
            button.addEventListener('mouseleave', function reset() {
                el.style.removeProperty('opacity');
                el.style.removeProperty('visibility');
                el.style.removeProperty('transform');
                button.removeEventListener('mouseleave', reset);
            }, { once: true });
        }
    });
});
$('.reputon-review-logo').attr('tabindex','0');
$('.boost-sd__search-bar-autocomplete h3.boost-sd__header-item').removeAttr('tabindex');
document.querySelectorAll('.tmenu_submenu_type_mega.tmenu_submenu--desktop[style*="width: 1080px"],.tmenu_submenu_type_tab.tmenu_submenu--desktop[style*="width: 1000px"]').forEach(function (el) {el.style.setProperty('width', '1350px', 'important');});


});
stampedBadgeObserver.observe(document.body, {childList: true,subtree: true});
$('<div>', {id: 'sr-announcer','aria-live': 'polite','aria-atomic': 'true',role: 'status',style: 'position:absolute; left:-9999px; height:1px; width:1px; overflow:hidden;'}).appendTo('body');
function announce(message) {
    const $announcer = $('#sr-announcer');
    $announcer.text('');
    setTimeout(function () {
        $announcer.text(message);
    }, 50);}
$(document).on(
    'click keydown','.boost-sd__prev-button .boost-sd__button, .boost-sd__next-button .boost-sd__button',
    function (e) {
        if (
            e.type === 'click' ||
            (e.type === 'keydown' &&
                (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'))
        ) {announce('Slide changed');}
});
if (!$('#quantity-sr-announcer').length) {
$('<div>', {id: 'quantity-sr-announcer','aria-live': 'polite','aria-atomic': 'true',role: 'status',style: 'position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;'}).appendTo('body');}
$(document).on('click', 'quantity-selector .plus, quantity-selector .minus', function () {
    const $button = $(this);
    const $input = $button.siblings('.qty');
    setTimeout(function () {const action = $button.hasClass('plus') ? 'Increased' : 'Decreased';
        $('#quantity-sr-announcer').text(action + ', quantity ' + $input.val());}, 100);
});
const clipboard = document.querySelector('social-share.share-article .clipboard');
if (clipboard) {
    new MutationObserver(function () {
        $(clipboard).attr('role',clipboard.classList.contains('clipboard-success') ? 'alert' : null
        );}).observe(clipboard, {attributes: true,attributeFilter: ['class']});
}
// 
$(document).on('keydown', 'quick-view.product-card-quickview,view-products.view-products,.stamped-wall-photos-wrapper .stamped-reviews-message-image-block a,.storeify-formbuilder form .bg-success ul li i.storeify-delete-file,#stamped-main-widget form.new-review-form .stamped-file-uploader-btn,shop-the-look.shop-the-look .shop-the-look--mobile quick-view,#Product-Drawer side-panel-close,.ht-tms__duo-selector__active-item', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
    }
});
$('.cd-faq .cd-faq-group li h4.cd-faq-trigger').each(function () {
    const $h4 = $(this);
    $h4.wrap('<div role="button" tabindex="0" class="main_cd-faq-trigger" aria-expanded="false"></div>');
    $h4.on('click', function () {
        $h4.parent().attr('aria-expanded', $h4.attr('aria-expanded') || ($h4.hasClass('active') ? 'true' : 'false'));
    });
});
$(document).on('click', '.cd-faq .cd-faq-group li h4.cd-faq-trigger', function () {
    const $h4 = $(this);
    const $content = $h4.closest('[itemprop="mainEntity"]').find('.cd-faq-content');

    setTimeout(function () {
        $content.css('display', $h4.hasClass('active') ? 'block' : 'none');
    }, 50);
});
$(document).on('keydown', '.main_cd-faq-trigger', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).find('h4.cd-faq-trigger').trigger('click');
    }
});
$(document).on('click', '.boost-sd__prev-button button, .boost-sd__next-button button', function () {
    const button = this;
    setTimeout(function () {button.focus();}, 950);
});
$('#main-content .section-blog-posts .blog-post aside').attr('role','none');
const tooltipEscObserver = new MutationObserver(function () {
    $('.boost-sd__tooltip-content').each(function () {
    if (!$(this).data('esc-bound')) {$(this).data('esc-bound', true);
    $(document).on('keydown.tooltipEsc', function (e) {if (e.key === 'Escape') {$('.boost-sd__tooltip-content').css('display', 'none');}});}});}
);tooltipEscObserver.observe(document.body, {childList: true,subtree: true});
if (window.matchMedia('(max-width: 767px)').matches) {
    if ($('footer#footer .widget--menu button').length) {
        $('footer#footer .widget--menu button').attr('aria-expanded', 'false');
        $('footer#footer .widget--menu button').each(function () {
            const $button = $(this);
            const $menu = $button.next('ul.thb-widget-menu');
            $menu.css('display', 'none');
            $button.on('click keydown', function (e) {
            if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const expanded = $button.attr('aria-expanded') === 'true';
            $button.attr('aria-expanded', expanded ? 'false' : 'true');
            $menu.css('display', expanded ? 'none' : 'block');}});});}
}
if ($('.flickity-slider .slideshow__slide-content .line-child').length) {$('.flickity-slider .slideshow__slide-content .line-child').each(function () {
        const $line = $(this);
        if (!$line.find('.sr-only').length) {const text = $line.text().trim().replace(/\s+/g, ' ');
        $line.attr('aria-hidden', 'true');$line.after('<div class="sr-only">' + text + '</div>');}});
}
if (window.innerWidth > 767) {
    if ($('footer#footer .widget--menu button').length) {$('footer#footer .widget--menu button').each(function () {$(this).replaceWith($('<div>', {class: $(this).attr('class'),html: $(this).html()}));});}
}
const swatchSelector = 'variant-swatch-king ul.swatch-view.swatch-view-image li.swatch-view-item[role="radio"]';
const swatchObserver = new MutationObserver(function () {
    if ($(swatchSelector).length) {
        document.addEventListener('keydown', function (e) {
            const item = e.target.closest(swatchSelector);
            if (!item || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            const items = document.querySelectorAll(swatchSelector);
            let index = Array.from(items).indexOf(item);
            index += e.key === 'ArrowRight' ? 1 : -1;
            if (index < 0) index = items.length - 1;
            if (index >= items.length) index = 0;
            items.forEach(function (el) {
                el.setAttribute('aria-checked', 'false');
                el.setAttribute('tabindex', '-1');});
            items[index].setAttribute('aria-checked', 'true');
            items[index].setAttribute('tabindex', '0');
            items[index].focus();}, true);
        document.addEventListener('keyup', function (e) {
            if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                const item = e.target.closest(swatchSelector);
                if (item) {
                    e.preventDefault();
                    e.stopImmediatePropagation();}}}, true);
        swatchObserver.disconnect();}
});
swatchObserver.observe(document.body, {childList: true,subtree: true});

(function () {
    function fixGraphicMenuLinks() {
        document.querySelectorAll('.tmenu_item_level_1 .tmenu_item_level_2 > .tmenu_item_link').forEach(function (graphicLink) {
            if (graphicLink.getAttribute('aria-label')) {return;}
            const parentItem = graphicLink.closest('.tmenu_item_level_1');
            if (!parentItem) {return;}
            const parentLink = parentItem.querySelector(':scope > .tmenu_item_link');
            if (!parentLink) {return;}
            const textElement = parentLink.querySelector(':scope > .tmenu_item_text');
            if (!textElement) {return;}
            const label = textElement.textContent.trim();
            if (label) {graphicLink.setAttribute('aria-label', label);}});
        document.querySelectorAll('.tmenu_item_layout_image > .tmenu_item_link').forEach(function (graphicLink) {
            const text = graphicLink.querySelector(':scope > .tmenu_image > .tmenu_item_text');
            if (!text) {return;}
            if (text.textContent.trim() !=='* Shop Flexible at Your Desire Height Boost') {return;}
            const image = graphicLink.querySelector(':scope > .tmenu_image');
            if (!image) {return;}
            if (text.parentElement === image) {graphicLink.insertBefore(text, image);}
            if (image.parentElement === graphicLink) {graphicLink.parentNode.insertBefore(image,graphicLink.nextSibling);}});}
    fixGraphicMenuLinks();
    const observer = new MutationObserver(function () {fixGraphicMenuLinks();});
    observer.observe(document.body, {childList: true,subtree: true});
})();
(function () {

    function fix(link) {
        if (!link.matches('.tmenu_item_link[role="tab"]')) return;

        link.removeAttribute('role');
        link.removeAttribute('aria-controls');
        link.removeAttribute('aria-selected');
        link.setAttribute('tabindex', '0');

        link.addEventListener('keydown', function (e) {

            if (e.key !== 'Tab') return;

            e.preventDefault();

            const items = Array.from(
                document.querySelectorAll(
                    'a[href], button, input, select, textarea, [tabindex="0"]'
                )
            ).filter(function (el) {
                return el.offsetParent !== null &&
                       !el.disabled;
            });

            const index = items.indexOf(link);

            if (index !== -1 && items[index + 1]) {
                items[index + 1].focus();
            }
        });
    }

    function watch(control) {
        control.querySelectorAll('.tmenu_item_link[role="tab"]').forEach(fix);
        new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes') {fix(mutation.target);}
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType !== 1) return;
                    if (node.matches('.tmenu_item_link[role="tab"]')) {
                        fix(node);}
                    node.querySelectorAll?.(
                        '.tmenu_item_link[role="tab"]'
                    ).forEach(fix);
                });});
        }).observe(control, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['role','tabindex','aria-controls','aria-selected']});}
    function findMenu() {
        var control = document.querySelector('.tmenu_submenu_tab_control');
        if (control) {
            watch(control);
            return true;}
        return false;}
    if (!findMenu()) {
        var observer = new MutationObserver(function () {
            if (findMenu()) {observer.disconnect();}});
        observer.observe(document.body, {childList: true,subtree: true
        });}
})();
(function () {
    function fix() {
        document.querySelectorAll('shopify-account').forEach(function (account) {
            var shadow = account.shadowRoot;
            if (!shadow) return;
            var header = shadow.querySelector('.account__header');
            if (header && header.getAttribute('role') !== 'none') {
                header.setAttribute('role', 'none');}});}
    fix();
    new MutationObserver(fix).observe(document.body, {childList: true,subtree: true});})();
// 
(function () {

    var trigger = null;

    function modal() {
        return document.querySelector(
            '.ht-tms__duo-selector__popup-modal--desktop'
        );
    }

    function fix() {

        var m = modal();
        if (!m) return;
        m.querySelectorAll(
    '.ht-tms__popup__form .ht-tms-single-list__container'
).forEach(function (list) {
    list.setAttribute('role', 'list');
});

m.querySelectorAll(
    '.ht-tms__popup__form .ht-tms-single-list__item'
).forEach(function (item) {
    item.setAttribute('role', 'listitem');
});
        m.querySelectorAll('.httms-search-box__input').forEach(function (input, i) {
            input.setAttribute(
                'aria-label',
                i === 0 ? 'Currency Search' : 'Language Search'
            );
        });
        m.querySelectorAll('.ht-tms__popup__title').forEach(function (heading) {
            heading.setAttribute('role', 'heading');
            heading.setAttribute('aria-level', '2');
        });
        m.querySelectorAll('.httms-search-box__inner').forEach(function (inner) {
            var svg = inner.querySelector('svg');
            if (svg) {
                svg.setAttribute('role', 'img');
                svg.setAttribute('aria-label', 'Search');
            }
        });
        m.querySelectorAll('.httms-search-box__input').forEach(function (input) {

    if (input.dataset.resultAnnounce) return;

    input.dataset.resultAnnounce = 'true';

    var live = document.createElement('div');

    live.className = 'search-result-count sr-only';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('aria-atomic', 'true');

    input.parentNode.appendChild(live);

    input.addEventListener('input', function () {

        setTimeout(function () {

            var wrapper = input.closest(
                '.ht-tms__popup__region-wrapper, .ht-tms__popup__language-wrapper'
            );

            if (!wrapper) return;

            var list = wrapper.querySelector(
                '.ht-tms-single-list__container'
            );

            var count = list
                ? list.querySelectorAll('.ht-tms-single-list__item').length
                : 0;

            live.textContent =
                count + (count === 1
                    ? ' result found'
                    : ' results found');

        }, 300);

    });

});
        m.querySelectorAll(
            '.ht-tms-single-list__item .tms-element-container'
        ).forEach(function (item) {
            var parent = item.closest('.ht-tms-single-list__item');
            if (!parent) return;
            var value = parent.getAttribute('data-value');
            if (!value) return;
            if (item.tagName.toLowerCase() !== 'button') {
                var button = document.createElement('button');
                Array.from(item.attributes).forEach(function (attr) {
                    button.setAttribute(attr.name, attr.value);
                });
                while (item.firstChild) {
                    button.appendChild(item.firstChild);
                }
                item.replaceWith(button);
                item = button;
            }
            item.setAttribute('type', 'button');
            var label = item.querySelector('.tms-element-text');
            if (label) {
                item.setAttribute(
                    'aria-label',
                    label.textContent.trim()
                );
            } else {
                item.setAttribute('aria-label', value);
            }
            if (parent.classList.contains(
                'ht-tms-single-list__item--active'
            )) {
                item.setAttribute('aria-current', 'true');
            } else {
                item.removeAttribute('aria-current');
            }
            var img = item.querySelector('img');
            if (img) {
                img.setAttribute('alt', value + ' Flag');
            }
        });
        m.querySelectorAll('*').forEach(function (el) {
            if (/[\u0900-\u097F]/.test(el.textContent.trim())) {
                el.setAttribute('lang', 'hi');
            }
        });
    }
    document.addEventListener('click', function (e) {
        var opener = e.target.closest(
            '.ht-tms__duo-selector__active-item'
        );
        if (!opener) return;
        trigger = opener;
        setTimeout(function () {
            fix();
            var first = modal()?.querySelector(
                '.httms-search-box__input'
            );
            if (first) first.focus();
        }, 150);
    }, true);
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var m = modal();
        if (!m || m.offsetParent === null) return;
        var items = Array.from(
            m.querySelectorAll(
                'input:not([disabled]),' +
                'button:not([disabled]),' +
                'a[href],' +
                'select:not([disabled]),' +
                'textarea:not([disabled]),' +
                '[tabindex="0"]'
            )
        ).filter(function (el) {
            return el.offsetParent !== null;
        });
        if (!items.length) return;
        if (
            e.shiftKey &&
            document.activeElement === items[0]
        ) {
            e.preventDefault();
            items[items.length - 1].focus();
        }
        if (
            !e.shiftKey &&
            document.activeElement === items[items.length - 1]
        ) {
            e.preventDefault();
            items[0].focus();
        }
    }, true);
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.ht-tms__popup__close')) return;
        setTimeout(function () {
            if (trigger) {
                trigger.focus();
            }
        }, 200);
    }, true);
    fix();
    new MutationObserver(function () {fix();}).observe(document.body, {childList: true,subtree: true});
})();
(function () {
    var trigger;
    function getBox() {
        return document.querySelector(
            '.boost-sd__search-bar-wrapper--desktop'
        );
    }
    document.addEventListener('click', function (e) {
        var t = e.target.closest('a.thb-quick-search');
        if (t) {
            trigger = t;
            setTimeout(function () {
                var box = getBox();
                var input = box && box.querySelector(
                    '.boost-sd__search-bar-input'
                );
                if (input) input.focus();
            }, 300);
        }
        if (e.target.closest('.boost-sd__button-text-x--close')) {
            setTimeout(function () {
                if (trigger) trigger.focus();
            }, 100);
        }
    }, true);
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var box = getBox();
        if (!box || box.offsetParent === null) return;
        var items = Array.from(box.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), ' +
            'select:not([disabled]), textarea:not([disabled]), [tabindex="0"]'
        )).filter(function (el) {
            return el.offsetParent !== null &&
                   getComputedStyle(el).visibility !== 'hidden';
        });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        }
        if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }, true);
})();
(function () {
    function fix() {
        document.querySelectorAll(
            '.boost-sd__format-currency--price-compare'
        ).forEach(function (el) {
            var price = el.querySelector('span[aria-label*="Compare price"]');
            if (!price || el.querySelector('.discounted-price-label')) return;
            price.setAttribute('aria-hidden', 'true');
            var label = document.createElement('span');
            label.className = 'discounted-price-label sr-only';
            label.textContent = 'Discounted price as: ' + price.textContent.trim();
            el.appendChild(label);
        });
    }

    fix();

    new MutationObserver(fix).observe(document.body, {
        childList: true,
        subtree: true
    });
})();
(function () {
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.product-card .product-card-quickview').forEach(function (tooltip) {
            var card = tooltip.closest('.product-card');
            if (!card) return;
            tooltip.style.setProperty('opacity', '0', 'important');
            tooltip.style.setProperty('visibility', 'hidden', 'important');
            tooltip.style.setProperty('transform', 'translateY(-50%)', 'important');
            card.addEventListener('mouseleave', function () {
                tooltip.style.removeProperty('opacity');
                tooltip.style.removeProperty('visibility');
                tooltip.style.removeProperty('transform');}, { once: true });
});}, true);})();
(function () {
    document.addEventListener('click', function (e) {
        var button = e.target.closest('.boost-sd__next-button button');
        if (!button) return;
        var live = document.querySelector('.slide-status');
        if (!live) {
            live = document.createElement('div');
            live.className = 'slide-status sr-only';
            live.setAttribute('role', 'status');
            live.setAttribute('aria-live', 'polite');
            document.body.appendChild(live);}
        live.textContent = 'Slide changed';
}, true);})();
// 
(function () {
    var tabs = document.querySelectorAll('.collection-tabs__list [role="tab"]');
    tabs.forEach(function (tab, i) {
        tab.setAttribute('aria-selected',tab.classList.contains('active') ? 'true' : 'false');
        tab.setAttribute('tabindex',tab.classList.contains('active') ? '0' : '-1');
        tab.addEventListener('keydown', function (e) {
            var index = i;
            if (e.key === 'ArrowRight') index = (i + 1) % tabs.length;
            if (e.key === 'ArrowLeft') index = (i - 1 + tabs.length) % tabs.length;
            if (index !== i) {e.preventDefault();
                tabs[index].focus();}});
        tab.addEventListener('click', function () {tabs.forEach(function (t) {t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        t.setAttribute('tabindex', t === tab ? '0' : '-1');});});});
})();
(function () {
    var live = document.createElement('div');
    live.className = 'sr-only';
    live.setAttribute('role', 'alert');
    document.body.appendChild(live);
    document.addEventListener('click', function (e) {
        var button = e.target.closest('.quantity-selector button');
        if (!button) return;
        live.textContent = '';
        setTimeout(function () {live.textContent = 'Loading';}, 100);}, true);
})();
(function () {
    var live = document.createElement('div');
    live.className = 'sr-only';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('aria-atomic', 'true');
    document.body.appendChild(live);
    document.addEventListener('click', function (e) {
        var option = e.target.closest('.boost-sd__sorting-option');
        if (!option) return;
        var value = option.textContent.trim();
        setTimeout(function () {live.textContent = '';
            setTimeout(function () {live.textContent ='Sorted by ' + value;}, 50);
        }, 300);}, true);}
)();
(function () {
    function updateSizeCheckboxes() {
        document.querySelectorAll('#pf_opt_us_size .boost-sd__filter-option-item-button[role="checkbox"]').forEach(function (button) {
            var label = button.querySelector('.boost-sd__filter-option-item-label');
            var amount = button.querySelector('.boost-sd__filter-option-item-amount');
            if (!label || !amount) return;
            var size = label.textContent.trim();
            var quantity = amount.textContent.replace(/[()]/g, '').trim();
            if (!size || !quantity) return;
            button.setAttribute('aria-label','US size ' + size + ', ' + quantity + ' available');
            button.setAttribute('aria-checked',button.classList.contains('boost-sd__filter-option-item-button--selected') ? 'true' : 'false');});}
    updateSizeCheckboxes();
    document.addEventListener('click', function (e) {
        var button = e.target.closest('#pf_opt_us_size .boost-sd__filter-option-item-button[role="checkbox"]');
        if (!button) return;
        setTimeout(function () {updateSizeCheckboxes();}, 300);}, true);
    var observer = new MutationObserver(function () {updateSizeCheckboxes();});
    observer.observe(document.body, {childList: true,subtree: true});
})();
(function () {
    var live = document.createElement('div');
    live.className = 'sr-only';
    live.setAttribute('role', 'alert');
    document.body.appendChild(live);
    document.addEventListener('click', function (e) {
        var button = e.target.closest('.quantity-selector button');
        if (!button) return;
        var selector = button.closest('.quantity-selector');
        var input = selector && selector.querySelector('input');
        if (!input) return;
        setTimeout(function () {live.textContent = 'Quantity ' + input.value;}, 100);
    }, true);})();

(function () {
    document.querySelectorAll('.section-media-grid .media-grid--item').forEach(function (item) {
        var video = item.querySelector('.media-grid--bg video');
        var button = item.querySelector('.video-play-pause');
        if (!video || !button) return;
        function updateButton() {
            if (video.paused) {button.innerHTML = '<span aria-hidden="true">▶</span>';
                button.setAttribute('aria-label', 'Play video');
            } else {button.innerHTML = '<span aria-hidden="true">❚❚</span>';
                button.setAttribute('aria-label', 'Pause video');}}
        updateButton();
        button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (video.paused) {video.play();
            } else {video.pause();}
            updateButton();});
        video.addEventListener('play', updateButton);
        video.addEventListener('pause', updateButton);
});
})();
(function () {
    document.querySelectorAll('.section-scrolling-images .scrolling-images').forEach(function (section) {

        var marquee = section.querySelector('.scrolling-images--inner');
        var button = section.querySelector('.scrolling-images-play-pause');

        if (!marquee || !button) return;

        button.innerHTML = '<span aria-hidden="true">❚❚</span>';

        button.addEventListener('click', function () {

            var paused = marquee.dataset.paused === 'true';

            marquee.style.setProperty(
                'animation-play-state',
                paused ? 'running' : 'paused',
                'important'
            );

            marquee.querySelectorAll(':scope > div').forEach(function (item) {
                item.style.setProperty(
                    'animation-play-state',
                    paused ? 'running' : 'paused',
                    'important'
                );
            });

            marquee.dataset.paused = paused ? 'false' : 'true';

            button.innerHTML = paused
                ? '<span aria-hidden="true">❚❚</span>'
                : '<span aria-hidden="true">▶</span>';

            button.setAttribute(
                'aria-label',
                paused ? 'Pause scrolling content' : 'Play scrolling content'
            );

        });

    });
})();
(function () {
    document.addEventListener('focusin', function (e) {
        var link = e.target.closest('.tmenu_item--root > .tmenu_item_link');
        if (!link) return;
        var li = link.parentElement;
        document.querySelectorAll('.tmenu_item--root.tmenu_item_active').forEach(function (item) {
            if (item === li) return;
            item.classList.remove('tmenu_item_active');
            var oldLink = item.querySelector(':scope > .tmenu_item_link');
            if (oldLink && oldLink.getAttribute('aria-expanded') !== 'false') {oldLink.setAttribute('aria-expanded', 'false');}});
        if (!li.classList.contains('tmenu_item_active')) {li.classList.add('tmenu_item_active');}
        if (link.getAttribute('aria-expanded') !== 'true') {link.setAttribute('aria-expanded', 'true');}});
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.tmenu_item--root.tmenu_item_active').forEach(function (item) {
            item.classList.remove('tmenu_item_active');
            var link = item.querySelector(':scope > .tmenu_item_link');
            if (link) {link.setAttribute('aria-expanded', 'false');}});
    });
})();



    
    console.log('ally end');
});